import React from "react";
export const VideoWrapper = ({ children }) => {
  return <>{children}</>;
};
